import * as tracking from '../tracking';
import {graphql} from 'react-relay';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation sharedReportChangePasswordMutation($input: SharedReportChangePasswordInput!) {
		sharedReportChangePassword(input: $input) {
			viewer {
				id
			}
			success
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Shared Report Change password');
	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {...input}},
		configs: [],
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
